import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'react-redux';
import type { AuthCodeState } from './slice';

export const getAuthCode = (state: RootState) => state.authCode;

export const getItem = createSelector(getAuthCode, (state: AuthCodeState) => state.item);
export const getError = createSelector(getAuthCode, (state: AuthCodeState) => state.error);

export const getIsLoggedIn = createSelector(getAuthCode, (state: AuthCodeState) =>
  Boolean(state.item.token),
);

export const getLoggedInUser = createSelector(
  getAuthCode,
  (state: AuthCodeState) => state.loggedInUser,
);
